const translations = {
  inventory: 'Inventory',
  contacts: 'Contacts',
  deals: 'Deals',
  account: 'Dealer',
  profile: 'Settings',
  api_keys: 'API Keys',
  accounts: 'Dealers',
  close: 'Close',
  logout: 'Log Out',
  analytics: 'Analytics',
  bulk_actions: 'Bulk Actions',
  expire: 'Expire',
  alliance_on: 'Alliance visibility ON',
  alliance_off: 'Alliance visibility OFF',

  current_account: 'Current acccount',
  select_account_to_operate: 'Select acccount',
  add_new_account: 'Add new account',
  or: 'or',

  error_modal_title: 'Error',
  error_modal_description: 'An error has occurred while performing the action. You can send a report to our support team.',
  error_id: 'Error ID',
  send_report: 'Send report',
  error_report_sent: 'Error report sent successfully',
};

export default translations;